export function isStockAssetType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "stock" || normalized === "a股";
}

// 数量单位：基金、ETF、LOF、REIT 按「份」，其余按「股」。核算页头部和「记录交易」弹窗
// 共用这一条，口径不许分叉——2026-09-16 线上走查发现核算页写「1300 份」、弹窗里同一只
// 基金却写「买入 200 股」。assetType 用后端解析过的类型（508001.SH 解析成 etf），
// 为空时再看代码后缀，库里 asset_type 为空的场外基金（005827.OF）也能判对。
export function quantityUnit(assetType, assetCode) {
  const type = String(assetType ?? "").trim().toLowerCase();
  const code = String(assetCode ?? "").trim().toUpperCase();
  const shares = code.endsWith(".OF") || ["fund", "etf", "lof", "reit"].some((token) => type.includes(token));
  return shares ? "份" : "股";
}
